const Colors = {
  primary: "#294256",
  secondary: "#EDF0FF",
  teritiary: "#D9D9D9",
  white38: "#ffffff61",
  shadowPrimary: "rgba(0, 0, 0, 0.2)",
  black14: "rgba(0, 0, 0, 0.14)",
  black: "#000000",
  white: "#ffffff",
  blueGray: "#8CA3B6",
  blueLight: "#C3EDF5",
  brownPrimary: "#887047",
  brownPrimaryLight: "#88704750",
  backgroundPrimary: "#F5F6FB",
  questionNotActive: "#968EEA",
  error: "orangered",
};

export default Colors;
